import { useLocation } from 'react-router-dom';
import { isBaaSRouteAuthorized, getBaaSRouteScope } from '@/config/baasRouteScopes';
import { BaaSAccessDenied } from './BaaSAccessDenied';

interface BaaSRouteGuardProps {
  children: React.ReactNode;
}

/**
 * Wraps every protected /baas/* page.
 * If the current route's status is 'access_denied' in BAAS_ROUTE_SCOPES,
 * renders the AccessDenied screen instead of the child page.
 */
export function BaaSRouteGuard({ children }: BaaSRouteGuardProps) {
  const { pathname } = useLocation();

  // Normalize: strip trailing slash, match exact path
  const normalizedPath = pathname.replace(/\/$/, '') || '/baas';

  if (!isBaaSRouteAuthorized(normalizedPath)) {
    const scope = getBaaSRouteScope(normalizedPath);
    return (
      <BaaSAccessDenied
        routePath={normalizedPath}
        label={scope?.label}
      />
    );
  }

  return <>{children}</>;
}
